import { NAME } from './constants';
import { menu } from './menu';
import { router } from './router';

export const Servis = {
	name: NAME,
	menu,
	router,
};
